import { Button } from '@ui/themed';
import type { ModalProps } from './types';

/** A modal's cancel/confirm pair. Polaris hands its actions to `s-modal` and skips this. */
export function ModalActions({
  primaryAction,
  secondaryAction,
}: Pick<ModalProps, 'primaryAction' | 'secondaryAction'>) {
  return (
    <>
      {secondaryAction && (
        <Button
          variant="secondary"
          onClick={secondaryAction.onClick}
          disabled={secondaryAction.disabled}
          loading={secondaryAction.loading}
        >
          {secondaryAction.text}
        </Button>
      )}
      {primaryAction && (
        <Button
          variant={primaryAction.danger ? 'danger' : 'primary'}
          onClick={primaryAction.onClick}
          disabled={primaryAction.disabled}
          loading={primaryAction.loading}
        >
          {primaryAction.text}
        </Button>
      )}
    </>
  );
}
